import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { FollowPresenterEffects } from './effects/follow-presenter.effects';
import { MeetingIssuesSettingsEffects } from './effects/issues-settings.effects';
import { MeetingAnalyticsEffects } from './effects/meeting-analytics.effects';
import { MeetingSchedulingEffects } from './effects/meeting-scheduling.effects';
import { MeetingsAnalyticsEffects } from './effects/meetings-analytics.effects';
import { MeetingsPageEffects } from './effects/meetings.effects';
import { MeetingsRealTimeBroadcastEffects } from './effects/real-time-broadcasts.effects';
import { MeetingsRealTimeSubscriptionsEffects } from './effects/real-time-subscriptions.effect';
import { MeetingsFeatureStateKey } from './meetings.model';
import { meetingsReducer } from './meetings.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(MeetingsFeatureStateKey, meetingsReducer),
    EffectsModule.forFeature([
      MeetingsPageEffects,
      MeetingsRealTimeBroadcastEffects,
      MeetingsRealTimeSubscriptionsEffects,
      MeetingSchedulingEffects,
      MeetingAnalyticsEffects,
      MeetingsAnalyticsEffects,
      FollowPresenterEffects,
      MeetingIssuesSettingsEffects,
    ]),
  ],
})
export class MeetingsStateModule {}
